import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { MarkRegCompleteToHomepageEdge } from '@app/registration/graph/edges/mark-reg-complete-to-homepage.edge';
import { NodeUrlMappingService } from '@app/registration/graph/node-url-mapping.service';
import { RegistrationNode } from '@app/registration/graph/nodes/registration.node';

@Injectable({
  providedIn: 'root',
})
export class MarkRegCompleteNode extends RegistrationNode {
  constructor(
    markRegCompleteToHomepageEdge: MarkRegCompleteToHomepageEdge,
    nodeUrlMappingService: NodeUrlMappingService,
    router: Router,
  ) {
    super(nodeUrlMappingService, router);
    this.edges = [markRegCompleteToHomepageEdge];
  }
}
